import React from "react";
import { Box } from "@mui/material";

export const mapMedicineSearchOption = (medicineItem) => {
  const brandedName = medicineItem.branded_name || "";
  const genericName = medicineItem.generic_name || "";
  let modifiedTerm = medicineItem.term || "";
  let displayPrimary = brandedName || medicineItem.term || "";
  let displaySecondary = "";

  if (brandedName) {
    if (medicineItem.term?.startsWith(brandedName)) {
      displaySecondary = medicineItem.term.slice(brandedName.length).trim();
    } else if (genericName) {
      displaySecondary = `(${genericName})`;
    }
  } else if (medicineItem.conceptFsn?.includes("(real clinical drug)")) {
    const matches = medicineItem.conceptFsn.match(/\(([^)]+)\)/);
    if (matches?.[1]) {
      const ingredient = matches[1].trim();
      modifiedTerm = `${medicineItem.term} (${ingredient})`;
      displayPrimary = medicineItem.term;
      displaySecondary = `(${ingredient})`;
    }
  }

  return {
    term: modifiedTerm,
    id: medicineItem.conceptId ?? medicineItem.id,
    branded_name: brandedName,
    generic_name: genericName,
    displayPrimary,
    displaySecondary,
    source: medicineItem.source || "snomed",
  };
};

export const MedicineOptionLabel = ({ option }) => (
  <Box
    component="span"
    sx={{
      display: "inline",
      textAlign: "left",
      whiteSpace: "normal",
      lineHeight: 1.35,
    }}
  >
    <Box component="span" sx={{ fontWeight: 700, color: "#000" }}>
      {option.displayPrimary || option.term}
    </Box>
    {option.displaySecondary ? (
      <Box
        component="span"
        sx={{
          fontWeight: 400,
          fontSize: "calc(1em - 1px)",
          ml: 0.5,
          color: "#000",
        }}
      >
        {option.displaySecondary}
      </Box>
    ) : null}
  </Box>
);
